/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LogOutAction from './LogOutAction/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Error({
  children,
  viewPath = "/App/RuntimeError/Error"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Error.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-4QcjJ': dtColorsWhite}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="🤯"
 fontSize={50}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 color="#e15829"
 text="Something went wrong"
 textAlign="center"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontWeight={300}
 hyphens="none"
 marginTop={30}
 text="We apologize for the inconvenience."
 textAlign="center"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontWeight={300}
 hyphens="none"
 marginTop={10}
 text="Report this problem to your clinic to help us solve it faster."
 textAlign="center"
/>
<div
  data-testid="Error.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<LogOutAction
  viewPath={`${viewPath}/LogOutAction`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}